import type { AppContext, AppEvents } from "@/types/scheduling";

import { errorToObject, } from "@/apps/appointment-scheduler/utils";
import { assertEvent } from "xstate";

export const handleAssignSlotsError = <T extends AppContext, E extends AppEvents>(context: T, event: E) => {
  assertEvent(event, "xstate.error.actor.apptActor");
  console.error(event.error);
  const errorInfo = errorToObject(event.error);

  const gtmEvent = {
    event: "appointment_selector_error",
    properties: {
      error_message: errorInfo.message,
      error_stack: errorInfo.stack,
    },
  };
  window.dataLayer.push(gtmEvent)
  return {
    ...context,
    errorMsg: errorInfo.message,
  };
}
